<studio-dialog>
  <studio-dialog-title
    text="Duplicate &quot;{{ projectSettings.name }}&quot;"
  ></studio-dialog-title>

  <form [formGroup]="duplicateForm">
    <studio-form-label
      for="projectName"
      text="Project name"
      [isRequiredField]="true"
    ></studio-form-label>
    <studio-form-input formControlName="projectName"></studio-form-input>

    <studio-form-error *ngIf="duplicateForm.get('projectName').hasError('required')">
      <p>Value is required.</p>
    </studio-form-error>
    <studio-form-error *ngIf="duplicateForm.get('projectName').hasError('minlength')">
      <p>Min length: 5</p>
    </studio-form-error>
    <studio-form-error *ngIf="duplicateForm.get('projectName').hasError('pattern')">
      <p>Characters allowed: alphanumeric, hyphen, underscore. No leading or trailing spaces.</p>
    </studio-form-error>
  </form>

  <studio-dialog-buttons-container>
    <studio-dialog-button
      text="Cancel"
      precedence="secondary"
      (click)="onCancelClick()"
    ></studio-dialog-button>
    <studio-dialog-button
      [disabled]="duplicateForm.invalid"
      text="Duplicate project"
      precedence="primary"
      (click)="onSaveClick()"
    ></studio-dialog-button>
  </studio-dialog-buttons-container>
</studio-dialog>
